import React, { FC } from 'react'

import { useFootnoteFooterContext } from '@/contexts'
import classNames from 'classnames'
import { COLORS, Footnote, Layout } from 'ethos-design-system'

import useWillsLPv4 from '@/hooks/features/useWillsLPv4'
import { useWreathsFooterUpdate } from '@/hooks/features/useWreathsFooterUpdate'

import Markdown, { MARKDOWN_NODE_RESTRICTION_SETS } from '../../Markdown'
import styles from './FootnoteFooter.module.scss'

interface IFootnoteFooter {
  footNoteColor?: any
}

const treatmentBodyText = `*Your use of the estate planning documents is subject to the [Terms of Service](/tomorrow-terms/) and [Privacy Policy](https://privacy.ethoslife.com/policies/). Ethos Estate Planning is not a law firm and our products and services are not a substitute for the advice of an attorney.  
  
Our Wills, Trust, and other estate planning document templates are approved by attorneys. The resulting documents will be compliant with state specific estate laws.  

Questions? [Contact us](/contact-us/).`

const FootnoteFooter: FC<IFootnoteFooter> = ({
  footNoteColor = COLORS.WHITE,
}) => {
  const { displayFootnoteFooter, bodyText: defaultBodyText } =
    useFootnoteFooterContext()

  const { isTreatment4 } = useWillsLPv4()

  const { isTreatment } = useWreathsFooterUpdate()

  if (!displayFootnoteFooter) return null

  let experimentBodyText = isTreatment4 ? treatmentBodyText : defaultBodyText

  if (experimentBodyText.length === 0) return null

  return (
    <Layout.HorizontallyPaddedContainer>
      <div
        id="footnote"
        className={classNames(styles.root, {
          [styles.treatment]: isTreatment,
        })}
      >
        <Footnote.Regular400 color={footNoteColor}>
          <Markdown
            input={experimentBodyText || ''}
            allowedMarkdownTypes={
              MARKDOWN_NODE_RESTRICTION_SETS.BASIC_TEXT_WITH_LINKS
            }
          />
        </Footnote.Regular400>
      </div>
    </Layout.HorizontallyPaddedContainer>
  )
}

export default FootnoteFooter
